import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ModalController, ToastController } from '@ionic/angular';
import { map } from 'rxjs';
import { OPTIONS_MASK, OPTIONS_MASK_QTDE } from 'src/app/core/constants/options-mask.constant';
import { PedidoService } from 'src/app/core/services/http/pedido.service';
import { KeyboardKeysEnum } from '../../enums/keyboard-keys.enum';
import { ModalRoleEnum } from '../../enums/modal-role.enum';
import { OperacaoPgtoEnum } from '../../enums/operacao-pgto.enum';
import { SangriaSuprimentoRequest } from '../../models/sangria-suprimento-request';
import { HelpersUtil } from '../../utils/helpers.util';
import { DialogStateUtil } from '../../utils/dialog-state.util';
import { CaixaService } from 'src/app/core/services/http/caixa.service';
import { AuthenticationService } from 'src/app/core/services/http/authentication.service';
import { ProdutoBalancaModel, ProdutoModel } from '../../models/produto.model';

@Component({
  selector: 'produto-qtde-venda-dialog',
  templateUrl: './produto-qtde-venda.component.html',
  //styleUrls: ['./sangria-suprimento-dialog.component.css']
})
export class ProdutoQtdeVendaDialogComponent implements OnInit { 
  public readonly produto: ProdutoBalancaModel;
  //--
  public readonly optionsMask = OPTIONS_MASK;
  public readonly optionsMaskQtde = OPTIONS_MASK_QTDE;

  public form = this._formBuilder.group({
    qtdeCtrl: new FormControl<number>(1, [Validators.required]),
    valorUnitCtrl: new FormControl<number>(0, [Validators.required]),
    valorTotalCtrl: new FormControl<number>(0, [Validators.required]),
  });
 
   constructor(
    private _formBuilder: FormBuilder,
    private _modalCtrl: ModalController,
    private toastCtrl: ToastController,
  ) { }

  public async cancelarAsyncOnClick() {
    await this._modalCtrl.dismiss(null, ModalRoleEnum.CANCEL);
    
    DialogStateUtil.dialogIsClosed();
  }

  public async confirmarAsyncOnClick() {
    await this._confirmarAsync();
  }

  public mudarFocoInputsOnKeydownEnter(indexInputAtual: number): void {
    const inputs = this._obterInputs();
    const indexProximoInput = (indexInputAtual + 1) % inputs.length;
    const proximoInput = inputs[indexProximoInput];

    proximoInput.focus();

    HelpersUtil.executeAfterDelay(() => proximoInput.select());
  }

  public ngOnInit() {
    HelpersUtil.executeAfterDelay(() => this._definirFocoPrimeiroInput());
  }

  @HostListener('window:keydown', ['$event'])
  private async _lidarComKeyboardEventAsync(event: KeyboardEvent): Promise<void> {
    if (event.key === KeyboardKeysEnum.F5 && !this.form.invalid) {
      event.preventDefault();
      event.stopPropagation();

      this._confirmarAsync();
    }
  }

  private async showToast(msg: string): Promise<void> {
    const toast = await this.toastCtrl.create({
      message: msg,
      duration: 2000,
      position: 'middle',
      color: 'tertiary'
    });

    await toast.present();
  }

  private async _confirmarAsync() {

    if (this.produto.qtde <= 0)
    {
      this.showToast('Valor não pode ser zero.');
      return;    
    }

    await this._modalCtrl.dismiss(this.produto, ModalRoleEnum.CONFIRM);

    DialogStateUtil.dialogIsClosed();
  }

  private _definirFocoPrimeiroInput(): void {
    const primeiroInput = this._obterPrimeiroInput();

    primeiroInput.focus();
    HelpersUtil.executeAfterDelay(() => primeiroInput.select());
  }

  private _obterInputs(): NodeListOf<HTMLInputElement> {
    return document.querySelectorAll('.control') as NodeListOf<HTMLInputElement>;
  }

  private _obterPrimeiroInput(): HTMLInputElement {
    return this._obterInputs().item(1);
  }
}

